export default "skymp5-front/a848642f1358043a6bf98e8d21a9c498.png";